import { AST } from '@handlebars/parser';

import { NodeType } from '../../../node/types';

export const isPartialBlockStatement = (
  statement: AST.Statement,
): statement is AST.PartialBlockStatement => statement.type === NodeType.PartialBlockStatement;
